import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>404!!! The Page you are looking for is Invalid!!</h1>
        </div>
    );
};

export default NotFound;